export const macros = [
  {
    title: 'Accept Messaging',
    body: 'Thank you for submitting the required documentation for provider. We have reviewed your submission and are pleased to inform you that your updates have been accepted. Please log in to your account to proceed with your application.',
  },
  {
    title: 'Reject Messaging',
    body: 'We regret to inform you that we are unable to proceed with your application. The document you have provided in this section does not meet the guidelines to establish.\nIf you have alternate documentation to support your application, please access your homepage and upload the additional documents for review.',
  },
  { title: 'Blank Message', body: '' },
]
